import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setActiveOrder } from '../orders/actions';
import { _getOrderData } from '../../services';

// ponytail: only the toolbar "Ref Number" search is used on /orders; the order lists and their
// polling were removed (the unclaimed-orders poll read every cart and OOM'd the api pods, T-202).
class OrderPageV3 extends React.Component {

    componentDidMount() {
        const target = new URLSearchParams(this.props.location.search).get('target')

        if (target) {
            _getOrderData(target)
                .then(res => this.props.setActiveOrder(res.data.order))
                .catch(e => console.log(e))
        }
    }

    render() {
        return null
    }
}

export default connect(
    null,
    dispatch => ({
        setActiveOrder: (order) => dispatch(setActiveOrder(order))
    })
)(
    withRouter( OrderPageV3 )
);



// WEBPACK FOOTER //
// ./src/components/orders-v3/orderPageV3.js